<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="paiement"
    size="small"
    label-position="left"
    label-width="210px"
  >
    <h2>Précisez le titulaire du contrat</h2>

    <el-form-item label="Nom de famille" prop="nom" required>
      <el-input v-model="form.nom" />
    </el-form-item>

    <el-form-item label="Prénom" prop="prenom" required>
      <el-input v-model="form.prenom" />
    </el-form-item>

    <el-form-item label="Adresse" prop="adresse" required>
      <el-input v-model="form.adresse" />
    </el-form-item>

    <el-form-item label="Code Postal" prop="codePostal" required>
      <el-input v-model="form.codePostal" />
    </el-form-item>

    <el-form-item label="Ville" prop="ville" required>
      <el-input v-model="form.ville" />
    </el-form-item>

    <el-form-item label="Email" prop="email" required>
      <el-input v-model="form.email" />
    </el-form-item>

    <el-card v-if="contract || phone" shadow="never">
      <el-button size="mini" @click="$router.push('/')">
        Changer les informations
      </el-button>

      <div v-if="phone">
        <i class="el-icon-mobile-phone" /> <strong>{{ phone }}</strong>
      </div>
      <div v-if="contract">
        <i class="el-icon-notebook-2" /> <strong>{{ contract }}</strong> ({{ reference }})
      </div>
    </el-card>

    <PaiementMontant />

    <PaiementStripe
      :stripe-complete.sync="stripeComplete"
      :show-error="stripeError"
      :show-paiement="showPaiement"
    />

    <el-alert
      v-if="error"
      type="error"
      title="Attention certains champs en rouge ne sont pas remplis correctement"
      :closable="false"
      center
    />

    <div class="valider">
      <el-button
        v-if="showPaiement"
        round
        icon="el-icon-caret-right"
        type="danger"
        :loading="loading"
        @click.prevent="valide"
      >
        Valider ma commande
      </el-button>

      <el-button
        v-else
        round
        icon="el-icon-caret-right"
        type="danger"
        @click="showPaiement = true"
      >
        Commande avec obligation de paiement
      </el-button>
    </div>
  </el-form>
</template>

<script>
import validator from 'validator'
import PaiementMontant from '../paiement/montant.vue'
import PaiementStripe from '../paiement/stripe.vue'

export default {
  props: {
    loading: Boolean,
    nom: String,
    prenom: String,
    adresse: String,
    ville: String,
    codePostal: String,
    email: String,
    contact: String,
    phone: String,
    optin: String,
    contract: String,
    reference: String,
    type: String
  },
  components: {
    PaiementMontant,
    PaiementStripe
  },
  data () {
    const email = (rule, value, callback) => {
      if (!value || !validator.isEmail(value)) {
        callback(new Error('Votre adresse email est invalide'))
      } else {
        callback()
      }
    }
    const zipcode = (rule, value, callback) => {
      if (this.form.receptionPays === 'France' && (!value || value.length > 5)) {
        callback(new Error('Votre code postal est invalide'))
      } else {
        callback()
      }
    }
    return {
      error: false,
      stripeComplete: false,
      stripeError: false,
      showPaiement: false,
      form: {
        nom: this.nom,
        prenom: this.prenom,
        adresse: this.adresse,
        ville: this.ville,
        codePostal: this.codePostal,
        email: this.email,
        optin: this.optin
      },
      rules: {
        nom: [
          { required: true, message: 'Saisissez le nom de famille de l\'abonné.', trigger: 'blur' }
        ],
        prenom: [
          { required: true, message: 'Saisissez le prénom de l\'abonné.', trigger: 'blur' }
        ],
        adresse: [
          { required: true, message: 'Saisissez l\'adresse de l\'abonné.', trigger: 'blur' }
        ],
        ville: [
          { required: true, message: 'Saisissez la ville.', trigger: 'blur' }
        ],
        codePostal: [
          { required: true, message: 'Saisissez le code postal.', trigger: 'blur' },
          { required: true, validator: zipcode, trigger: 'blur' }
        ],
        email: [
          { required: true, validator: email, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    valide () {
      this.$refs.paiement.validate((valid) => {
        this.error = !valid
        this.stripeError = !!(valid && !this.stripeComplete)
        if (valid && this.stripeComplete) {
          this.$emit('valide', this.form)
        }
      })
    }
  },
  watch: {
    nom (value) {
      this.form.nom = value
    },
    prenom (value) {
      this.form.prenom = value
    },
    adresse (value) {
      this.form.adresse = value
    },
    codePostal (value) {
      this.form.codePostal = value
    },
    ville (value) {
      this.form.ville = value
    },
    email (value) {
      this.form.email = value
    },
    optin (value) {
      this.form.optin = value
    },
    form: {
      handler (value) {
        if (value) {
          this.$emit('update:nom', value.nom)
          this.$emit('update:prenom', value.prenom)
          this.$emit('update:adresse', value.adresse)
          this.$emit('update:codePostal', value.codePostal)
          this.$emit('update:ville', value.ville)
          this.$emit('update:email', value.email)
          this.$emit('update:optin', value.optin)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  h2 {
    margin-bottom: 30px;
  }
  .el-form {
    max-width: 620px;
    margin: 0 auto 25px !important;

    > .el-card {
      text-align: left;
      font-size: 13px;
      line-height: 18px;

      .el-button {
        float: right;
      }
    }
  }
  .valider {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/paiement.vue